<script>
  import axios from 'axios'

  let timer;
  export default {
    props: {
      params: Object
    },
    data() {
      return {}
    },
    methods: {
      logout() {
        this.$emit('auth', false);
        axios.get('/tourclient/account/logout?_=' + (new Date().getTime()))
          .then(data => {
          }).catch(err => {
          reject();
        })
      }
    },
    computed: {
      href() {
        if (this.params && this.params['ret']) {
          return this.params['ret'];
        } else {
          return '/tourclient/admin/';
        }
      }
    },
    watch: {},
    components: {},
    mounted() {
      timer = setTimeout(() => {
        window.location.href = this.href;
      }, 10000);
    },
    destroyed() {
      clearTimeout(timer);
    }
  }
</script>
<template>
  <div class="main main-auth">
    <div class="wrap">
      <div class="main__title">Вы уже авторизованы</div>
      <div class="main-auth__string">
        <div>Перенаправление в Личный кабинет....</div>
        <div><a :href="href">Перейти</a></div>
        <div><span @click="logout">Войти под другим именем</span></div>
      </div>
    </div>
  </div>
</template>